import "@/App.css";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7d2c299e-2a66-4c7c-93d4-45200dfcb215/artifacts/s1ccpbw8_IMG_0492.jpeg";

function App() {
  return (
    <div className="App" data-testid="simple-coin-app">
      <main className="landing-container">
        <div className="logo-wrapper" data-testid="logo-wrapper">
          <img 
            src={LOGO_URL} 
            alt="Simple Coin Logo" 
            className="logo"
            data-testid="simple-coin-logo"
          />
        </div>
        <h1 className="brand-name" data-testid="brand-name">Simple Coin</h1>
        <p className="tagline" data-testid="tagline">a simple website for a simple coin</p>
      </main>
    </div>
  );
}

export default App;
